
import Vue from "vue";
declare var $: any;
import Highcharts from "@/components/Highchart.vue";
import API from "../service/config";
import { post, fetch, patch, put, toDelete } from "../service/http-service";
import { Loading } from "element-ui";

export default Vue.extend({
  name: "Details",
  components: {
    Highcharts,
  },
  data() {
    return {
      id: "",
      isShow: false,
      tab: "summary",
      datasetId: "",
      datas: {} as any,
      exploreData: [] as any,
      exploreActive: "",
      exploreSrc: "",
      isHighcharts: false,
    };
  },
  created() {
    // const url = window.location.href;
    // const regex: RegExp = /\/([A-Za-z0-9]+)$/; // 匹配最后一个斜杠后面的字符串
    // const match: RegExpMatchArray | null = url.match(regex);
    // const field: string | undefined = match?.[1]; // 获取匹配到的字符串
    // console.log(this.$route.params.id);
    this.id = this.$route.params.id;
  },
  mounted() {
    this.getExplore();
    this.getMetadata();
  },
  beforeMount() {},
  methods: {
    showData() {
      this.isShow = !this.isShow;
    },
    tabFun(value: string) {
      this.tab = value;
    },
    getMetadata() {
      let tableData: any = null;
      let postData: any = {
        index: 1,
        size: 10,
        value: "",
        tableType: "datasetId",
        visualization: null,
        species: null,
        diseases: null,
        tissueType: null,
        libraryProtocol: null,
        cellType: null,
        datasetId: null,
        type: "id",
        isasc: true,
        visitTable: false,
      };
      let datasetIdArr = [this.$route.params.id];
      postData.datasetId = datasetIdArr;
      post(API.domainUrl + API.getMetadata, postData).then((response: any) => {
        if (response.status.code == 200) {
          tableData = response.data.records;
          this.datas = this.$store.state.detailData.id
            ? this.$store.state.detailData
            : tableData[0] || "";
          sessionStorage.setItem("setDetailData", JSON.stringify(tableData[0]));
        }
      });
    },
    clickExplore(name: string, value: string) {
      this.exploreActive = name;
      this.exploreSrc = "http://" + value;
      if (name == "Immune abundance browser") {
        this.isHighcharts = true;
      } else {
        this.isHighcharts = false;
      }
    },
    getExplore() {
      fetch(API.domainUrl + API.getExplore + "?dataset=" + this.id).then(
        (response: any) => {
          if (response.status.code == 200) {
            this.exploreData = response.data.data;
            let firstExplore: any = this.exploreData[0];
            this.clickExplore(firstExplore.name, firstExplore.value);
          } else {
            this.$message.error(response.status.msg);
          }
        }
      );
    },
  },
  computed: {
    data: function () {
      return this.$store.state.detailData.id
        ? this.$store.state.detailData
        : JSON.parse(sessionStorage.getItem("setDetailData") as string) || "";
    },
  },
});
